export default __webpack_public_path__ + "static/media/onboarding-share-with-friends-whatsapp.13ee25f1.png";